let locale, real, langPath;

if (typeof window.poskiLocale === "undefined")
    window.poskiLocale = {
        locale: 'cs'
    };

locale = window.poskiLocale;
real = window.poskiReal;
langPath = window.poskiLangPath;


window.EnhancedSelectCollection = [];
window.EnhancedSelect = () => {
    const setMultiLabel = (select) => {}; // TODO: přiblížit se původním SumoSelectům

    document.querySelectorAll('select:not([data-native-select])').forEach(el => {
        EnhancedSelectCollection.push(tail.select(el, {
            sourceBind: true,
            placeholder: locale.sumo_select_vyberte,
            locale: "multiLanguage",
            height: 250,
        }));
    });
};
window.EnhancedSelectRebuild = (selectName) => {
    const targetSelect = EnhancedSelectCollection.find(select => select.e.name === selectName);
    if (typeof(targetSelect) !== 'undefined') {
        targetSelect.e.removeAttribute('data-tail-select');
        targetSelect.e.removeAttribute('style');
        targetSelect.e.parentNode.querySelector('.tail-select').remove();

        EnhancedSelect();
    }
}

/*encoding: utf-8 */
document.addEventListener("DOMContentLoaded", function() {

    // sledovani udalosti
    window.trackFrontendEvent = function (controller, event, data) {

        let request = new XMLHttpRequest();
        request.overrideMimeType("application/json");
        request.open('GET', langPath + '@track?c=' + controller + '&ev=' + event + '&' + dataToQueryString(data), true);
        request.send();

        return request;
    };

    // prettyselect
    window.EnhancedSelect();

    // vypočti stejnou výšku na elementy
    window.matchHeight = function () {
        if (typeof MatchHeight !== 'undefined')
            new MatchHeight(document.querySelectorAll('.js-sameHeight'));
    };
    window.matchHeight();

    // lazyloading
    window.lazyLoad = () => {
        if (typeof LazyLoad === 'undefined')
            return;

        new LazyLoad({
            elements_selector: ".js-lazy",
            load_delay: 300
        });
    };
    window.lazyLoad();

    (function () { // Cookies lišta
        let cookieConsent = document.querySelector('#js-cookie-consent');
        if(typeof(cookieConsent) === 'undefined' || cookieConsent === null)
            return;

        let setLinks = document.querySelectorAll('.js-cookie-consent-set');
        for (let i = 0; i < setLinks.length; i++) {
            setLinks[i].addEventListener('click', function (event) {
                let r = new XMLHttpRequest();
                r.open("GET", event.target.href, true);
                r.send();
                event.preventDefault();
                cookieConsent.style.display = 'none';
            });
        }
    })();

    (function () { // Generovane menu z BE
        let menu = document.querySelector('.JS-menu')
        if(typeof(menu) === 'undefined' || menu === null)
            return;

        if(document.querySelector('ul.menu > li.active'))
            return;

        menu.querySelectorAll('li.active').forEach((el) => {
            el.parents('li').forEach(parent => {
                parent.classList.add('active');
            });
        });
    })();

    // zastupne texty u selectu TODO: ověřit nutnost kódu
    // (function () {
    //     var selector = 'select[name="pobvod"], select[name="stari"], select[name="pobocka"], select[name="typsmlouvy"], select[name="typnemovitosti"], select[name="kraj"], select[name="okres"], select[name="obec"], select[name="cobce"], select[name="dispozice"]';
    //     $('body').delegate(selector, 'focus blur change', function (ev) {
    //         var $select = $(ev.currentTarget);
    //
    //         $select.find('option').addClass('normal').filter(':first').removeClass('normal').addClass('placeholder');
    //         if ($select.find('option:first').is(':selected')) {
    //             $select.addClass('placeholder');
    //         } else {
    //             $select.removeClass('placeholder');
    //         }
    //     });
    //     $(selector).trigger('blur');
    // }());

    (function () { // odesilani na zmenu, schovani submitu ve vypisu
        const forms = [...document.querySelectorAll('form')].filter(el => {
            return el.id === 'nemovitosti-sort' || el.id === 'nemovitosti-limit' || el.id === 'hledame-filter'
        });

        forms.forEach(form => {
            form.querySelectorAll('select').forEach(select => {
                select.addEventListener('change', () => {
                    select.closest('form').submit();
                });
            });

            const formSubmit = form.querySelector('.sumbit');
            if(typeof(formSubmit) !== undefined && formSubmit !== null)
                formSubmit.style.display = 'none';
        });
    }());

    (function () { // odesilani na zmenu, schovani submitu ve vypisu
        const elements = document.querySelectorAll('.AutoSubmit');

        elements.forEach(el => {
            el.addEventListener('change', () => {
               el.closest('form').dispatch(new Event('submit'));
            });
        });
    }());

    (function () { // inicializace prMapy
        if (typeof window.prNemovitostMapsItems === 'undefined' || typeof PRNemovitostiMaps === 'undefined')
            return;

        let options = (window.prNemovitostMapsOptions !== 'undefined' ? window.prNemovitostMapsOptions : {});
        PRNemovitostiMaps.initialize(window.prNemovitostMapsItems, options);
        PRNemovitostiMaps.run();
    }());

    (function () { // smooth scroll přes kotvy
        let scrollAnchors = document.querySelectorAll('.js-scroll');
        if(!scrollAnchors.length)
            return;

        scrollAnchors.forEach((el) => {
           el.addEventListener('click', (e) => {
               e.preventDefault();

               let headerHeight = 0;
               let fixedHeader = document.querySelector('.js-header-fixed');
               if(typeof(fixedHeader) !== 'undefined' && fixedHeader !== null)
                   headerHeight = parseFloat(getComputedStyle(fixedHeader, null).height.replace("px", ""));

               let full_url = el.href,
                   parts = full_url.split("#"),
                   target = document.querySelector('#'+ parts[1]);
               if(typeof(target) === 'undefined' || target === null)
                   return;

               window.scroll({
                  behavior: "smooth",
                  left: 0,
                  top: target.offsetTop - headerHeight
               });
           })
        });
    }());

    (function () { // ScrollUp tlačítko
        if ((window.setting === "undefined" && !window.setting.FRONTEND_SETTING_FRAME_SCROLL_UP) || document.body.clientWidth <= 800)
            return;

        let scrollUp = document.createElement('a');
        scrollUp.classList.add('scrollup');
        scrollUp.style.display = 'none';

        scrollUp.addEventListener('click', () => {
            window.scroll({ behavior: "smooth", top: 0, left: 0 });
        });

        document.body.appendChild(scrollUp);

        window.addEventListener('scroll', () => {
            animJs.fadeToggle(scrollUp, window.scrollY > 240);
        });
    }());

    (function () {
        let content = document.querySelector('[data-marketing-content]');
        if(typeof(content) === 'undefined' || content === null)
            return;

        const data = {
            'page-location': content.getAttribute('data-page-location'),
            'page-locale': content.getAttribute('data-page-locale')
        }

        let request = new XMLHttpRequest();
        request.open('GET', '/@marketing-code?' + dataToQueryString(data), true);

        request.onload = function() {
            if (this.status >= 200 && this.status < 400 && this.response)
                content.innerHTML = this.response;
        };
        request.send();
    }());


    //Rozbalování sekcí
    (function () {
        let button = document.querySelector('[data-section-button]'),
            content = document.querySelector('[data-section-content]');
        if(typeof(content) === 'undefined' || content === null || typeof(button) === 'undefined' || button === null)
            return;

        button.addEventListener('click', (e) => {
            e.preventDefault();

            if (!content.classList.contains('is-active')) {

                content.classList.add('is-active');
                button.classList.add('is-active');

            } else {
                content.classList.remove('is-active');
                button.classList.remove('is-active');
            }

        });
    }());
});
